import { Tag } from "primereact/tag";
import { useGetCategoryQuery } from "../store/api/directory/categoryApi"
import { getStatus } from "./partial";


export const adressColumn = [
    {
        attr: "guid",
        label: "Text",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        label: "Text",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "country",
        label: "Страна",
        type: 1,
        hidden: false,
        editor: true
    },

    {
        attr: "address_line",
        label: "Адрес ",
        type: 1,
        hidden: false,
        editor: true
    },

    {
        attr: "address_line2",
        label: "Адрес 2",
        type: 1,
        hidden: false,
        editor: true
    },

    {
        attr: "city",
        label: "Город",
        type: 1,
        opt: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "currency",
        label: "currency",
        type: 3,
        opt: 2,
        hidden: false,
        editor: false
    },
    {
        attr: "postcode",
        label: "postcode",
        type: 1,
        opt: 2,
        hidden: false,
        editor: true
    },
    {
        attr: "state",
        label: "region",
        type: 1,
        hidden: false,
        editor: true
    },

    {
        attr: "phone",
        label: "Номер",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "client",
        label: "client",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "currency_guid",
        label: "currency_guid",
        type: 3,
        opt: 2,
        hidden: true,
        editor: true
    },
    {
        attr: "desc",
        label: "desc",
        type: 1,
        hidden: false,
        editor: true
    }

]

export const categoryColumn = [
    {
        attr: "guid",
        label: "Text",
        type: 1,
        hidden: true,
        editor: false
    }, {
        attr: "name",
        label: "Категория",
        type: 1,
        hidden: false,
        editor: true
    }, {
        attr: "name_en",
        label: "Category",
        type: 1,
        hidden: false,
        editor: true
    }
]

export const currencyColumn = [
    {
        attr: "guid",
        label: "Text",
        type: 1,
        hidden: true,
        editor: false
    }, {
        attr: "name",
        label: "currency",
        type: 1,
        hidden: false,
        editor: true
    }, {
        attr: "name_en",
        label: "currency",
        type: 1,
        hidden: false,
        editor: true
    }
]

export const warehouseColumn = [
    {
        attr: "guid",
        label: "Text",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "codeid",
        label: "Text",
        type: 1,
        hidden: true,
        editor: false
    },
    {
        attr: "warehouse",
        label: "warehouse",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "country",
        label: "country",
        type: 3,
        opt: 5,
        optionLabel: "country",
        optionValue: "guid",
        hidden: false,
        editor: true
    },
    {
        attr: "district",
        label: "region",
        type: 3,
        opt: 4,
        hidden: false,
        editor: true
    },
    {
        attr: "adress",
        label: "adres",
        type: 1,
        hidden: false,
        editor: true
    },
    {
        attr: "status",
        label: "Название",

        hidden: true,
        editor: false
    },
    {
        attr: "date_created",
        label: "date_create",
        type: 4,
        hidden: false,
        editor: false
    }
]